import moment from "moment";
import { color } from "../resources";

export const delay = (ms = 500) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const convertDateTimeThailand = (date = new Date()): string => {
  if (!date) return "";
  const [d, m, y] = moment(date).format("DD-MM-YYYY").split("-");
  const yToNumber = Number(y);
  return `${yToNumber + 543}-${m}-${d} ${moment(date).format("HH:mm:ss")}`;
};

export const convertDateTime = (date = new Date()): string => {
  const [y, m, d] = moment(date).format("YYYY-MM-DD").split("-");
  return `${y}-${m}-${d}`;
};

export const getPropertiesStatus = (status: string) => {
  switch (status) {
    case "WAITING-CONFIRM":
    case "STCH-001":
      return {
        color: color.mustardYellow,
        text: "รอตรวจสอบ",
      };
    case "STDH-003":
      return {
        color: color.mustardYellow,
        text: "พร้อมขาย",
      };
    case "STPH-002": // WAITING-KEEP-DEVICE
    case "STPH-003": // WAITING-TRACKING
    case "WAITING-INVOICE":
      return {
        color: color.mustardYellow,
        text: "",
      };
    case "STDH-002":
      return {
        color: color.orange,
        text: "รอ QC จากโรงงาน",
      };
    case "STPH-004": // WAITING-PD-WORK
    case "WAITING-QC":
      return {
        color: color.orange,
        text: "",
      };
    case "STDH-100":
      return {
        color: color.green,
        text: "ใช้งานอยู่ปกติ",
      };
    case "AVAILABLE":
      return {
        color: color.green,
        text: "",
      };
    case "STDH-005":
      return {
        color: color.overlay,
        text: "กำลังซ่อม/เปลื่ยน",
      };
    case "MAINTENANCE":
      return {
        color: color.overlay,
        text: "",
      };
    case "STPH-005": // WAITING-MC-WORK
      return {
        color: color.red_pink,
        text: "",
      };
    case "STPH-100": // COMPLETED-REPAIR
    case "STCH-100":
    case "COMPLETE-CONFIRM":
      return {
        color: color.green,
        text: "ตรวจสอบแล้ว",
      };
    case "STPH-006": // WAITING-MC-CLOSED
      return {
        color: color.orange_red,
        text: "",
      };
    case "STRH-001":
      return {
        color: color.mustardYellow,
        text: "รอออก SaleOrder",
      };
    case "STRH-002":
      return {
        color: color.orange,
        text: "รอออก Invoice",
      };
    case "STRH-100":
      return {
        color: color.green,
        text: "จองเรียบร้อย",
      };
    case "STSH-001":
      return {
        color: color.orange,
        text: "รอเครื่องสแปร์",
      };
    case "STSH-100":
      return {
        color: color.green,
        text: "ส่งเรียบร้อย",
      };
    case "STDH-200":
      return {
        color: color.orange,
        text: "เคลมโรงงาน",
      };
    case "STDH-201":
      return {
        color: color.overlay,
        text: "ทำลาย",
      };
    case "STD-011":
      return {
        color: color.green,
        text: "Activate",
      };
    case "STD-099":
      return {
        color: color.red,
        text: "Deactivate",
      };
    case "STD-000":
      return {
        color: color.overlay,
        text: "Maintain",
      };
    case "STD-299":
      return {
        color: color.overlay,
        text: "Delete",
      };
    default:
      return {
        color: color.red,
        text: "",
      };
  }
};

export const convertStrRepair = (text: string): string => {
  if (text === "สินค้าเสีย เปลี่ยนเครื่องใหม่(เคลม)") {
    return "เคลม";
  }

  if (text === "สินค้าเสียส่งซ่อม ขอเบิกเครื่องสแปร์") {
    return "ซ่อม - มีแสปร์";
  }
  return "ซ่อม";
};

export const onSort = (a: any, b: any, key: string) => {
  if (a[key] < b[key]) {
    return -1;
  }
  if (a[key] > b[key]) {
    return 1;
  }
  return 0;
};

export const compairStatus = (status: string) => {
  switch (status) {
    case "STRH-001":
      return "รอออก SaleOrder";
    case "STRH-002":
      return "รอออก Invoice";
    case "STRH-100":
      return "จองเรียบร้อย";
  }
};

export function numWithComma(number: number, digit = 0, locale = "en-US") {
  return new Intl.NumberFormat(locale, { maximumFractionDigits: digit }).format(
    number,
  );
}
